<template>
  <d-container class="h-100">
    <d-row class="h-100 align-items-center">
      <d-col class="main-content p-0" tag="main" sm="12">
        <d-row class="login-form justify-content-center">
          <d-col cols="12" md="8" lg="7" xl="6">
            <div class="title">
              <img
                id="main-logo"
                src="@/assets/images/logonovo.png"
                alt="Total Grass"
                >
            </div>
          </d-col>
        </d-row>
        <d-row class="login-form justify-content-center">
          <d-col cols="12" md="8" lg="7" xl="6">
            <alert :fixed="false" ></alert>
            <d-card class="card-small mb-4 p-4">

              <!-- Content -->
              <router-view></router-view>

            </d-card>
          </d-col>
        </d-row>

        <!-- Footer -->
        <footer class="main-footer d-flex p-2 px-3">
          <div class="container">
            <div class="align-items-center row h-100 text-center">
              <span class="copyright col-12 ml-auto my-auto mr-2">Copyright © 2019-{{new Date().getFullYear()}} <d-link href="http://sync360.io" target="_blank">Sync360.io</d-link></span>
            </div>
          </div>
        </footer>
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
import Alert from '_shared/Alert.vue';

export default {
  name: 'login',
  components: {
    Alert,
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.title {
  color: #fff;
  font-size: 18px;
  margin: 0 0 15px 0;
  justify-content: center;
  height: 110px;
  align-items: center;
  display: flex;
  img {
    max-height: 80px;
    max-width: 80%
  }
}
</style>
